module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Text/Text-0f965706e619c42c534230bfd0d7381ab43c48958de920e884f8e62bb5767541.svg";